import { ReactNode, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { ClickableTooltip } from "~/app/components/ClickableTooltip"
import { IconWithTooltip } from "@oysterhr/feature-components"

type SectionTitleProps = {
  title: string
  subtitle?: string
  isOptional?: boolean
  endAdornment?: ReactNode
  /** @deprecated Use endAdornment instead */
  tooltip?: string | (() => void)
  testId?: string
}

export const SectionTitle = ({
  title,
  subtitle = undefined,
  isOptional = false,
  endAdornment = undefined,
  tooltip,
  testId,
}: SectionTitleProps) => {
  const { t } = useTranslation("company_interface/CompanyNewHireFTEPage")

  const correctTooltip = useMemo(() => {
    if (typeof tooltip === "string") {
      return <IconWithTooltip className="ml-2" value={tooltip} />
    }
    if (typeof tooltip === "function") {
      return (
        <span className="ml-2">
          <ClickableTooltip onClick={tooltip} />
        </span>
      )
    }
    return null
  }, [tooltip])

  return (
    <div>
      <div data-testid={testId} className="mt-8 flex w-full items-center space-x-2">
        <h2 className="text-lg font-semibold text-black">
          {title}
          {isOptional && (
            <span className="ml-2 text-base font-medium text-gray-300">
              {t("sectionTitles.optional")}
            </span>
          )}
        </h2>
        {endAdornment}
        {correctTooltip}
      </div>
      {subtitle && (
        <div className="mt-4 w-full">
          <p className="base-text-medium text-gray-400">{subtitle}</p>
        </div>
      )}
    </div>
  )
}
